import { useMutation } from 'react-query';
import { useToastContext } from 'shared/components/Toast/context/ToastContext';
import { procedureService } from 'shared/services/ProcedureService';
import { IAddProcedure } from '../../interfaces/IProcedure';

export const useAddProcedure = () => {
    const { showToast } = useToastContext();

    const { mutateAsync, isError, isLoading } = useMutation(
        (procedureForm: IAddProcedure) => {
            return procedureService.addProcedure(procedureForm);
        },
        {
            onSuccess: () => {
                showToast('success', 'Procedure added');
            },
            onError: (error: any) => {
                console.log('Error on posting procedure - ');
                showToast('error', error?.detail);
            },
        }
    );

    return {
        mutateAsync,
        isLoading,
        serverErrorMessage: isError,
    };
};
